import React from 'react'

const CheckboxHeader = () => {
  return (
    <div style={{textAlign: "left"}} >yes || no</div>  )
}

export default CheckboxHeader